import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import { Map, tileLayer, marker, icon } from 'leaflet';

/**
 * Generated class for the DeliveryTakeawaySalesMapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delivery-takeaway-sales-map',
  templateUrl: 'delivery-takeaway-sales-map.html',
})
export class DeliveryTakeawaySalesMapPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  //datatable
  rows = [];
  temp = [];
  //ID_DOC AS uid_ticket, DELIVERY AS delivery, SALES AS total, ADDRESS AS zone
  columns = [{ prop: 'delivery', name: this.translate.instant('general-delivery') },
  { prop: 'total', name: this.translate.instant('general-total') + " (" + this.globals.currency_symbol + ")" },
  { prop: 'zone', name: this.translate.instant('general-direccion') }];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController) {
    this.getAnalyticsData();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);


    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/delivery_get_zones', params, {})
      .subscribe(async res => {
        var response = res;
        //map
        this.initMap(response['map']);
        //list
        this.rows = response['list'];
        this.temp = response['list'];
        //
        this.chartCheck = true;//boolean check
      });

  }

  map: any;
  mapMarkers: any = [];
  initMap(data) {
    //case no initial map (create new map)
    if ((document.getElementById('map') as HTMLInputElement).value == undefined) {
      var map = new Map('map').setView([this.globals.restaurant.lat, this.globals.restaurant.lng], 8);
      map.addLayer(tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: ''
      }));
      this.map = map;
    }
    //config marker icon
    const customMarkerIcon = icon({
      iconUrl: './assets/icons/gps.png',
      iconSize: [24, 32],
      popupAnchor: [0, -20]
    });
    //remove markers
    if (this.mapMarkers) {
      for (var i = 0; i < this.mapMarkers.length; i++) {
        this.map.removeLayer(this.mapMarkers[i]);
      }
    }
    //add new markers
    for (let item of data) {
      var _marker = marker([item.lat, item.lng], { icon: customMarkerIcon }).addTo(this.map);
      //_marker.bindPopup(item.delivery);
      this.mapMarkers.push(_marker);
    }
    //set map to html element
    (document.getElementById('map') as HTMLInputElement).value = this.map;
  }


  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.delivery.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const params = new HttpParams()
      .set('data', JSON.stringify(this.rows))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({}));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/delivery-takeaway-sales-map/delivery-takeaway-sales-map.ts